<ng-template #pageTitle>
  <h5 class="text-neutral-900 font-semibold text-2xl ps-2xl">
    {{ 'notification_page_title' | transloco }}
  </h5>
</ng-template>

<ng-template #headerActions>
  <div class="flex items-center gap-lg">
    <button
      type="button"
      class="font-medium bg-transparent border-none text-sm"
      [disabled]="!hasUnreadNotifications()"
      [class.text-primary-500]="hasUnreadNotifications()"
      [class.text-neutral-300]="!hasUnreadNotifications()"
      [class.cursor-pointer]="hasUnreadNotifications()"
      (click)="handleMarkAllAsRead()">
      {{ 'mark_all_notifications_as_read' | transloco }}
    </button>
    <button
      type="button"
      class="bg-white rounded-lg p-sm border-none cursor-pointer flex items-center"
      (click)="handleSettingsClick()">
      <lib-setting-icon [iconClass]="'size-5 text-neutral-500'" />
    </button>
  </div>
</ng-template>

<div
  class="flex flex-col"
  [class.h-full]="!floating() || centerEmptyState()"
  [class.min-h-full]="floating() && !centerEmptyState()"
  [class]="
    centerEmptyState()
      ? systemTabsPageClasses() + ' ' + emptyPageMinHeight()
      : systemTabsPageClasses()
  ">
  @if (floating()) {
    <lib-tabs
      [tabSegmented]="systemTabs()"
      [tabsBorder]="!systemTabs()"
      tabsHeaderClass="mb-lg"
      [tabsStartRef]="pageTitle"
      [tabActionSectionRef]="headerActions"
      (selectTab)="
        handleNotificationTabChange(notificationFilterTabs()[$event])
      ">
      @for (tab of notificationFilterTabs(); track tab.key) {
        <lib-tab
          [tabTitle]="tab.label"
          [showTabTag]="tab.count !== undefined"
          [tabTag]="tab.count" />
      }
    </lib-tabs>
  }

  <div
    class="flex flex-col flex-1"
    [class.items-center]="centerEmptyState()"
    [class.justify-center]="centerEmptyState()"
    [class.bg-white]="floating()"
    [class.rounded-lg]="floating()">
    <lib-notification
      class="w-full"
      [class.flex-1]="!centerEmptyState()"
      [notifications]="notifications()"
      width="100%"
      [height]="notificationHeight()"
      [maxNotifications]="50"
      [showHeader]="!floating()"
      [showTabs]="!floating()"
      [notificationFilterTabs]="notificationFilterTabs()"
      noStateIconSize="size-35"
      noStateDescriptionSize="text-xl"
      noStateTitleSize="text-2xl"
      [hasTitleBottomBorder]="false"
      [isLoading]="isLoading()"
      [useScrollPagination]="false"
      (handleNotificationFilterTab)="handleNotificationTabChange($event)"
      (notificationClick)="handleNotificationClick($event)"
      (markAllAsRead)="handleMarkAllAsRead()"
      (settingsClick)="handleSettingsClick()"
      (viewDetailsClick)="handleViewDetailsClick($event)"></lib-notification>

    @if (hasVisibleNotifications()) {
      <lib-paginator
        class="bottom-0 bg-white mt-2xl flex-shrink-0 border-t border-neutral-200 px-xl"
        [class.rounded-b-lg]="floating()"
        [sizeOptionsLabel]="
          'pagination_number_of_rows_per_page_label' | transloco
        "
        [nextBtnLabel]="'pagination_next_button_label' | transloco"
        [previousBtnLabel]="'pagination_previous_button_label' | transloco"
        [currentPage]="currentPage()"
        [totalPages]="totalPages()"
        [totalItems]="totalItems()"
        [showChangeSize]="true"
        [sizeOptions]="pageSizeOptions"
        (goTo)="handlePagination($event)"
        (next)="handlePagination($event)"
        (previous)="handlePagination($event)"
        (handleChangeSize)="changeSize($event)"
        [currentSize]="currentSize()" />
    }
  </div>
</div>
